<template>
  <div>
    <!-- 弹窗-积分操作 -->
    <y-dialog
      title="积分操作"
      width="600px"
			:visible="isShowDialog && isShowType == 1"
      :before-close="cancelBtn"
      @comfirm="saveScores"
      @close="cancelBtn"
      sureText="保存"
      >

			<el-form ref="form" :model="pointForm" label-width="120px">
				<el-form-item label="全渠道会员ID：">{{ editItem.memberId }}</el-form-item>
				<el-form-item label="当前积分">
					<el-input v-model="editItem.pointBalance" :disabled="true" style="width: 186px;"></el-input>
				</el-form-item>
				<el-form-item label="修改积分：" required>
            <div class="displayItem">
              <el-select
                class="selectType"
                v-model="pointForm.scoresType"
                placeholder="请选择"
                style="width: 186px;"
                size="small"
              >
                <el-option
                  v-for="item in integralList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
              <el-input
                size="small"
                placeholder="请输入"
                style="width: 186px;margin-left: 8px;"
								oninput="value=value.replace(/^\.+|[^\d.]/g,'')"
								maxlength="8"
                show-word-limit
                v-model="pointForm.scoresCount"
              ></el-input>
            </div>
        	</el-form-item>
					<el-form-item label="备注：" required>
              <el-input
                size="small"
                placeholder="请输入"
                style="width: 380px;"
								maxlength="20"
                show-word-limit
                v-model="pointForm.remark"
              ></el-input>
        	</el-form-item>
			</el-form>
    </y-dialog>

		<!-- 弹窗-等级修改 -->
    <y-dialog
      title="等级修改"
      width="600px"
			:visible="isShowDialog && isShowType == 2"
      :before-close="cancelBtn"
      @comfirm="saveGrade"
      @close="cancelBtn"
      sureText="保存"
      >

			<el-form ref="gradeForm" :model="gradeForm" label-width="120px">
				<el-form-item label="全渠道会员ID：">{{ editItem.memberId }}</el-form-item>
				<el-form-item label="当前等级">
					<!-- 根据 memberLevelList 动态显示当前等级名称 -->
					<el-input :value="currentGradeLabel" :disabled="true" style="width: 186px;"></el-input>
				</el-form-item>
				<el-form-item label="等级修改为：" required>
            <div class="displayItem">
              <el-select
                class="selectType"
                v-model="gradeForm.grade"
                placeholder="请选择"
                style="width: 186px;"
                size="small"
              >
                <el-option
                  v-for="item in selectableLevelList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>
        </el-form-item>
				<el-form-item label="等级有效期：" >
						<div class="my_select_time1">
                <el-date-picker
                  prefix-icon="no_icon"
                  v-model="gradeForm.gradeValidTime"
                  value-format="yyyy-MM-dd"
									type="date"
                  :placeholder="'选择日期时间'"
                  size="small"
                  style="width: 186px; font-size: 12px"
                  class="time2"
                  :clearable="false"
                ></el-date-picker>
              <i class="el-icon-circle-close date_icon1" @click="clearTimeSendTime()"></i>
              <img src="@/assets/images/select_date.svg" alt class="date_icon2" />
            </div>
						<div style="font-size: 13px;font-weight: 400;color: #999999;">不设置即为永久有效</div>
				</el-form-item>
				<el-form-item label="备注：" required>
              <el-input
                size="small"
                placeholder="请输入"
                style="width: 380px;"
								maxlength="20"
                show-word-limit
                v-model="gradeForm.remark"
              ></el-input>
        </el-form-item>
			</el-form>
    </y-dialog>

		<!-- 弹窗-成长值操作 -->
    <y-dialog
      title="成长值操作"
      width="600px"
			:visible="isShowDialog && isShowType == 3"
      :before-close="cancelBtn"
      @comfirm="saveGrow"
      @close="cancelBtn"
      sureText="保存"
      >

			<el-form ref="growForm" :model="growForm" label-width="120px">
				<el-form-item label="全渠道会员ID：">{{ editItem.memberId }}</el-form-item>
				<el-form-item label="当前成长值">
					<el-input v-model="editItem.grow" :disabled="true" style="width: 186px;"></el-input>
				</el-form-item>
				<el-form-item label="修改成长值：" required>
            <div class="displayItem">
              <el-select
                class="selectType"
                v-model="growForm.scoresType"
                placeholder="请选择"
                style="width: 186px;"
                size="small"
              >
                <el-option
                  v-for="item in growList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
              <el-input
                size="small"
                placeholder="请输入"
                style="width: 186px;margin-left: 8px;"
								oninput="value=value.replace(/^\.+|[^\d.]/g,'')"
								maxlength="8"
                show-word-limit
                v-model="growForm.scoresCount"
              ></el-input>
            </div>
        	</el-form-item>
					<el-form-item label="备注：" required>
              <el-input
                size="small"
                placeholder="请输入"
                style="width: 380px;"
								maxlength="20"
                show-word-limit
                v-model="growForm.remark"
              ></el-input>
        	</el-form-item>
			</el-form>
    </y-dialog>
  </div>
</template>

<script>
import { editScores,editGrow,editGrade } from '@/api/memberMessageSystem'
export default {
  components: {

  },
	props: {
    isShowDialog: {
      type: Boolean,
      default: false
    },
		isShowType:{
			type: Number,
		},
		editItem:{
			type:Object,
		},
		// 会员等级列表，由父组件（memberAll.vue）传入，格式 [{ label, value }]
		memberLevelList:{
			type: Array,
			default: () => []
		}
  },
  data() {
    return {
 
      gradeForm: {
        memberId:this.editItem.memberId,
				grade:'',
				gradeValidTime:'',
				remark:''
      },
      pointForm:{
        memberId:this.editItem.memberId,
        scoresCardId:'',
        scoresType:0,
        scoresCount:'',
        remark:''
      },
      growForm:{
        memberId:this.editItem.memberId,
        scoresType:0,
        scoresCardId:'',
        scoresCount:'',
        remark:''
      },
			integralList:[
				{
					value:0,
					label:'加积分'
				},
				{
					value:1,
					label:'减积分'
				},
			],
			growList:[
				{
					value:0,
					label:'加成长值'
				},
				{
					value:1,
					label:'减成长值'
				},
			],
    };
  },
  created() {
    // 获取当前会员体系详情
    this.MemberSystemInfo = this.$store.state.MemberSystemInfo
    console.log("this.MemberSystemInfo",this.MemberSystemInfo);
  },
  computed: {
    // 当前等级名称：按 editItem.grade 在父组件传入的列表里查 label
    currentGradeLabel() {
      if (
        this.editItem.grade === "" ||
        this.editItem.grade === null ||
        this.editItem.grade === undefined
      ) {
        return "-";
      }
      const level = (this.memberLevelList || []).find(
        (item) => String(item.value) === String(this.editItem.grade)
      );
      return level ? level.label : this.editItem.grade;
    },
    // 可选等级：去掉父组件列表里「全部」这一项（value 为空），并排除当前等级，
    // 避免把等级改成它本身
    selectableLevelList() {
      return (this.memberLevelList || []).filter((item) => {
        if (
          item.value === "" ||
          item.value === null ||
          item.value === undefined
        ) {
          return false;
        }
        return String(item.value) !== String(this.editItem.grade);
      });
    },
  },
  mounted() {
    this.pointForm.scoresCardId=this.MemberSystemInfo.scoresCardId
    this.growForm.scoresCardId=this.MemberSystemInfo.scoresCardId
  },
  methods: {
		//清除时间
		clearTimeSendTime(){
			this.form.time=''
		},
    //保存修改积分
    saveScores(){
      
      if(!this.pointForm.scoresCount){
        this.$message.warning("请输入修改的积分");
        return;
      }

      if(this.pointForm.scoresType == 1 && Number(this.pointForm.scoresCount) > Number(this.editItem.pointBalance) ){
        this.$message.warning("请减少的积分不能大于当前积分");
        return;
      }

      if(!this.pointForm.remark){
        this.$message.warning("请输入备注");
        return;
      }

      this.pointForm.scoresCount = Number(this.pointForm.scoresCount)
      editScores(this.pointForm).then((res) => {
        if (res.code == 200) {
          this.$emit("finishEdit");
        }else{
          this.$message.warning("编辑失败");
          this.$emit("close");
        }
      });
    },
    //保存修改成长值
    saveGrow(){
      if(!this.growForm.scoresCount){
        this.$message.warning("请输入修改的成长值");
        return;
      }

      if(this.growForm.scoresType == 1 && Number(this.growForm.scoresCount) > Number(this.editItem.grow) ){
        this.$message.warning("请减少的成长值不能大于当前成长值");
        return;
      }

      if(!this.growForm.remark){
        this.$message.warning("请输入备注");
        return;
      }
      this.growForm.scoresCount = Number(this.growForm.scoresCount)
      editGrow(this.growForm).then((res) => {
        if (res.code == 200) {
          this.$emit("finishEdit");
        }else{
          this.$message.warning("编辑失败");
          this.$emit("close");
        }
      });
    },
    // 保存弹窗
    saveGrade(){
      if(!this.gradeForm.grade){
        this.$message.warning("请输入修改的等级");
        return;
      }
      if(!this.gradeForm.remark){
        this.$message.warning("请输入备注");
        return;
      }
      editGrade(this.gradeForm).then((res) => {
        if (res.code == 200) {
          this.$emit("finishEdit");
        }else{
          this.$message.warning("编辑失败");
          this.$emit("close");
        }
      });
    },
    // 取消弹窗
    cancelBtn(){
      // this.$refs['ruleForm'].resetFields();
      this.$emit("close");
    }
  },
};
</script>

<style lang="scss" scoped>
.displayItem{
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.my_select_time1 {
  position: relative;
  display: inline-block;
  .time2 {
    width: 145px;
  }
	/deep/.el-input--prefix .el-input__inner {
    padding-left: 10px;
	}
	.date_icon2,.date_icon1 {
        position: absolute;
        /* top: 10px; */
        right: 5px;
        height: 32px;
        line-height: 32px;
        width: 16px;
        font-size: 16px;
    }


    .date_icon1 {
        display: none;
        cursor: pointer;
    }
}

.my_select_time1:hover {
    .date_icon2 {
        display: none;
    }

    .date_icon1 {
        display: inline-block;
    }
}

</style>